import { FC } from 'react'

import { Typography } from '@lib-components'
import { InputLabelProps } from '@lib-types'

export const InputLabel: FC<InputLabelProps> = (props) => {
  return <Typography variant={'body-2'} tag={'label'} {...props} />
}
